
import { HttpImporterList} from '@/service/logistics';
import TableList from "@components/templates/tablelist";

import comIndex from './update'
import { mapGetters } from 'vuex';
import mixin from '../mixin';

export default {
    mixins: [TableList, mixin],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            addressCodeList:[],
            formData: {
                search: {
                },
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            title:"",
            entitle:"",
            Plugins: { show: true },
        };
    },
    created() {
      },
    methods: {
        ajaxRequest: HttpImporterList,
       
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show:true,
                        width:800,
                        component: "comIndex",
                        type:'add',
                        showFooter:false,
                    }
                    break;  
                case 'query':
                this.operate = {
                    title: this.$t('global.common.query', { defaultValue: '查看' }),
                    show:true,
                    width:800,
                    component: "comIndex",
                    activeid:params,
                    type:'query',
                    showFooter:false,
                }
                break;                 
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show:true,
                        width:800,
                        component: "comIndex",
                        activeid:params,
                        type:'edit',
                        showFooter:false,
                    }
                    break;
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB+ "/api/v2/importer/batchExport", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show:true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show:true,
                params: id,
                operate: 'edit'
            }
          ]
        },
        
    },
    computed: {
        ...mapGetters('dictionary', []),
        ToolsData() {
            
            return [{
                name: this.$t('global.common.add', { defaultValue: "添加" }),
                operate: "add",
                theme: "primary",
            },{
                name: this.$t('global.common.export', { defaultValue: "导出" }),
                operate: "export",
                theme: "success",
            },]
        },
        SearchsData() {
            return [{
                    label: this.$t('fbb.headlogistics.import_name', { defaultValue: '进口商名称' }),
                    key: 'CN_name',
                    tag: 'vInput',
                    width:150,
                    show: true,
                }
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 90,
                    render: this.getOperateNodes
                },{
                    title: this.$t('fbb.headlogistics.import_name', { defaultValue: '进口商名称' }),
                    key: 'name',
                }, {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'status',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getImporterStatus, row.status)
                }, {
                    title: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key: 'country',
                }, {
                    title: this.$t('fbb.headlogistics.address_detail', { defaultValue: '详细地址' }),
                    key: 'address',
                }, {
                    title: this.$t('fbb.headlogistics.receiver', { defaultValue: '收货人' }),
                    key: 'receiverName',
                }, {
                    title: this.$t('global.common.mobile', { defaultValue: '移动电话' }),
                    key: 'phone',
                }, {
                    title: this.$t('fbb.headlogistics.receiver_telephone', { defaultValue: '固定电话' }),
                    key: 'telephone',
                }, {
                    title: this.$t('fbb.headlogistics.receiver_note', { defaultValue: '其他联系方式' }),
                    key: 'other',
                }, {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                }];
        },
    },
};




